// Selector "¿Dónde quieres instalarla?" — soporta el parámetro de URL
// ?uso=cochera|patio|jardin|entrada|negocio para que las campañas de
// anuncios lleguen directo con el contenido correcto ya seleccionado.
// Si no hay parámetro, o no coincide con ninguna opción, se queda el
// contenido general (nunca se oculta información por esto).
(function () {
  var ESPACIOS_VALIDOS = ['cochera', 'patio', 'jardin', 'entrada', 'negocio'];

  function iniciar(contenedor) {
    var botones = Array.prototype.slice.call(contenedor.querySelectorAll('[data-tz-uso-boton]'));
    var paneles = Array.prototype.slice.call(contenedor.querySelectorAll('[data-tz-uso-panel]'));

    function mostrar(espacio) {
      var panelObjetivo = contenedor.querySelector('[data-tz-uso-panel="' + espacio + '"]');
      if (!panelObjetivo) return;

      paneles.forEach(function (p) { p.classList.remove('is-activo'); });
      panelObjetivo.classList.add('is-activo');

      botones.forEach(function (b) {
        var activo = b.dataset.tzUsoBoton === espacio;
        b.classList.toggle('is-activo', activo);
        b.setAttribute('aria-selected', activo ? 'true' : 'false');
      });
    }

    botones.forEach(function (boton) {
      boton.addEventListener('click', function () {
        var espacio = boton.dataset.tzUsoBoton;
        mostrar(espacio);

        // Actualiza la URL sin recargar, para que el link se pueda
        // compartir/guardar ya con ese espacio seleccionado.
        var url = new URL(window.location.href);
        url.searchParams.set('uso', espacio);
        window.history.replaceState({}, '', url);
      });
    });

    // Si la campaña de anuncios trae ?uso=cochera (etc.), seleccionarlo
    // automáticamente al cargar la página.
    var parametros = new URLSearchParams(window.location.search);
    var usoDesdeUrl = parametros.get('uso');
    if (usoDesdeUrl && ESPACIOS_VALIDOS.indexOf(usoDesdeUrl) !== -1) {
      mostrar(usoDesdeUrl);
    }
  }

  document.querySelectorAll('[data-tz-uso]').forEach(iniciar);
})();
